import React from "react";

const achievementsData = [
  {
    award: "1st Place",
    event: "Hack with Tricity Hackathon",
    organizer: "Chandigarh University",
    description: "Built a university event management system",
    year: "2025",
  },
  {
    award: "1st Place",
    event: "CodeCraft Hackathon",
    organizer: "Pandora Club, Chandigarh University",
    description: "Proposed an automated calling management system",
    year: "2023",
  },
  {
    award: "3rd Place",
    event: "Chase Code 1.0",
    organizer: "CSI, Chandigarh University",
    description: "Debugging and coding rounds",
    year: "2022",
  },
];

const Achievements = () => {
  return (
    <section
      id="achievements"
      className="layout-container py-24 md:py-32 border-t border-borderSubtle scroll-fade"
    >
      {/* Section Header */}
      <div className="flex flex-col">
        <span className="text-xs font-mono tracking-widest text-accent uppercase font-medium">
          <p>/ 04 / ACHIEVEMENTS</p>
        </span>
        <h2 className="text-xl font-normal text-white mt-2">
          Awards & Recognition
        </h2>
      </div>

      {/* Achievements List */}
      <div className="flex flex-col mt-12">
        {achievementsData.map((item, index) => (
          <div
            key={index}
            className="group flex flex-col md:flex-row md:items-center justify-between py-6 border-b border-borderSubtle/50 last:border-b-0 border-l-2 border-transparent hover:border-accent pl-4 md:pl-6 transition-all duration-300"
          >
            <div className="flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-6">
              {/* Year */}
              <span className="text-xs font-mono text-zinc-400 w-16 select-none">
                {item.year}
              </span>

              {/* Place / Award */}
              <span className="text-sm font-mono text-accent uppercase tracking-wider font-medium sm:w-28">
                {item.award}
              </span>

              <div className="flex flex-col">
                {/* Event Title */}
                <span className="text-base text-zinc-200 font-normal mt-1 sm:mt-0">
                  {item.event}
                </span>

                {/* Description */}
                <span className="text-zinc-400 text-sm md:text-base leading-relaxed font-normal">
                  {item.description}
                </span>
              </div>
            </div>

            {/* Organizer */}
            {item.organizer && (
              <span className="text-xs font-mono text-zinc-400 mt-2 md:mt-0 select-none">
                / {item.organizer}
              </span>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Achievements;
